import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../../app.component';
import { AppService } from '../../app.service';
import { DatasetModel } from '../../share/models/dataset-model.model';
import { ApiService } from '../../share/services/api.service';
import { AngularSlickgridModule, Column, Filters, Formatters, GridOption, MultipleSelectOption } from 'angular-slickgrid';
import { FieldType } from 'angular-slickgrid';
// import { ShareServiceClient } from '@azure/storage-file-share';
import FetrapiEnums from '../../share/enum/enums';
import { Member } from '../../share/models/member.model';
import { SharedModule } from '../../share/shared.module';
import { TextExportService } from '@slickgrid-universal/text-export';

const shareName = "fetrapishare";
// const serviceClient = new ShareServiceClient('https://merkatorfetrapiresourceg.file.core.windows.net/?sv=2019-12-12&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-10-10T00:10:35Z&st=2020-10-09T16:10:35Z&spr=https&sig=I6veUT7AKpUC7lTEanO66NmwvktQ7u6K8X%2F3AH6bQ8s%3D');

@Component({
  selector: 'app-approval',
  templateUrl: './approval.component.html',
  styleUrls: ['./approval.component.css'],
  imports: [SharedModule, AngularSlickgridModule]
})
export class ApprovalComponent implements OnInit {

  datasets: DatasetModel[] = [];
  isLoaded = false;
  columnDefinitions: Column[] = [];
  gridOptions: GridOption = {};
  dataset: DatasetModel[] = [];
  members: Member[] = [];
  numberofrows: number = 100;

  constructor(private appService: AppService, private api: ApiService, private appComponent: AppComponent) {}

  ngOnInit(): void {
    this.gridOptions = {
      enableGridMenu: true,
      enableSorting: true,
      enableFiltering: true,
      enableHeaderButton: true,
      enableHeaderMenu: true,
      forceFitColumns: true,
      autoResize: {
        container: '#grid-container', // container DOM selector
      },
      enableAutoResize: true,
      enablePagination: true,
      rowHeight: 42,
      pagination: {
        pageSizes: [5, 10, 15, 20, 25, 50, 75, this.numberofrows],
        pageSize: 15,
      },
      enableTextExport: true,
      textExportOptions: {
        exportWithFormatter: true,
      },
      externalResources: [new TextExportService()],
      gridMenu: {
        hideExportCsvCommand: false,
        hideExportTextDelimitedCommand: false,
        hideExportExcelCommand: false,
        hideClearAllSortingCommand: false,
        hideForceFitButton: false,
        onBeforeMenuShow: (a, b) => {},
      },
    };

    this.loadDatasets();

  }

  ngAfterViewInit() {

  }

  loadDatasets() {
    // Helper
    const StringIsAlphanumerical = (value: string) => isNaN(Number(value)) === true;

    this.api.getDataSets('"ZoI","Grid","ADCRExport","Chapter3Export","IntegratedGridData","KLIMCICCBuffer"', null).subscribe({
      next: (data: any) => {
        this.datasets = data;
        console.log("results found: " + this.datasets.length);

        this.numberofrows = 0;
        this.datasets.forEach(element => {
          element.id = element.datasetId;
          element.dateTimeCreated = new Date(element.dateTimeCreated);
          this.numberofrows++;
        });
        //console.log(data);
        this.isLoaded = true;
        this.gridOptions.pagination = {
          pageSize: 15,
          pageSizes: [5, 10, 15, 20, 25, 50, 75, this.numberofrows]
        };

        // fill the dataset with your data
        this.dataset = this.GetProductionDatasets;
        var DatasetTypes = [...new Set(this.dataset.map(item => item.datasetType))].sort();
        var StatusCodes = [...new Set(this.dataset.map(item => item.statusCode))].sort();
        var MemberList = [...new Set(this.dataset.map(item => item.memberName))].sort();
        // TODO waarom bestaat item.memberOf niet ? voorlopig gemapped op memberName om voort te kunnen
        var MemberGroup = [...new Set(this.dataset.map(item => item.memberName))].sort();

          // TODO as unknown as MultipleSelectOption lijkt een gekke oplossing
          this.columnDefinitions = [
          { id: 'MemberName', name: 'MemberName', field: 'memberName', sortable: true, filterable: true, type: FieldType.string, filter: { collection: Object.values(MemberList).filter(StringIsAlphanumerical).map(k => ({ value: `${k}`, label: `${k}` })), model: Filters['multipleSelect'], filterOptions: { offsetLeft: 14 } as unknown as MultipleSelectOption, placeholder: 'Filter on Member' } },
          { id: 'MemberGroup', name: 'MemberGroup', field: 'memberOf', sortable: true, filterable: true, type: FieldType.string, filter: { collection: Object.values(MemberGroup).filter(StringIsAlphanumerical).map(k => ({ value: `${k}`, label: `${k}` })), model: Filters['multipleSelect'], filterOptions: { offsetLeft: 14 } as unknown as MultipleSelectOption, placeholder: 'Filter on Member Group' } },
          { id: 'dateTimeCreated', name: 'Submitted', field: 'dateTimeCreated', filterable: true, sortable: true, formatter: Formatters['dateTimeEuro'], type: FieldType.dateTimeEuro, outputType: FieldType.dateTimeEuro, filter: { model: Filters['dateRange'] } },
          { id: 'datasetType', name: 'datasetType', field: 'datasetType', sortable: true, filterable: true, type: FieldType.string, filter: { collection: Object.values(DatasetTypes).map(k => ({ value: `${k}`, label: `${k}` })), model: Filters['multipleSelect'], filterOptions: { offsetLeft: 14 } as unknown as MultipleSelectOption, placeholder: 'Filter on Dataset Type' } },
          { id: 'id', name: 'Dataset ID', field: 'id', sortable: true, filterable: true, type: FieldType.string },
          { id: 'statusCode', name: 'statusCode', field: 'statusCode', filterable: true, sortable: true, type: FieldType.string, filter: { collection: Object.values(StatusCodes).filter(StringIsAlphanumerical).map(k => ({ value: `${k}`, label: `${k}` })), model: Filters['multipleSelect'], filterOptions: { offsetLeft: 14 } as unknown as MultipleSelectOption, placeholder: 'Filter on log type' } },
          { id: 'Approve', name: 'Approve', field: '', excludeFromExport: true, width: 35, formatter: this.reportApproveFormatter, onCellClick: (e, args) => { this.approveDataset(args.dataContext); } },
          { id: 'Reject', name: 'Reject', field: '', excludeFromExport: true, width: 35, formatter: this.reportRejectFormatter, onCellClick: (e, args) => { this.rejectDataset(args.dataContext); } },
          { id: 'Download', name: 'Download', field: '', excludeFromExport: true, width: 35, formatter: this.reportDownloadFormatter, onCellClick: (e, args) => { this.downloadDataset(args.dataContext); } }
        ];

      }
    })
  }


  get GetProductionDatasets() {
    return this.datasets;
    //return this.datasets.filter( x => x.statusCode != "Archived");
  }
  reportApproveFormatter(row: number, cell: number, value: any, columnDef: Column, dataContext: DatasetModel) {
    if (dataContext.statusCode == "MemberApproved" && dataContext.datasetType == FetrapiEnums.DatasetType.ZoI) return "<button type='button' class='btn btn-sm btn-default'>Approve</Button>";
    return "";
}
  reportRejectFormatter(row: number, cell: number, value: any, columnDef: Column, dataContext: DatasetModel) {
    if (dataContext.statusCode == "MemberApproved" && dataContext.datasetType == FetrapiEnums.DatasetType.ZoI) return "<button type='button' class='btn btn-sm btn-default'>Reject</Button>";
    return "";
}
  reportDownloadFormatter(row: number, cell: number, value: any, columnDef: Column, dataContext: DatasetModel) {
    if (dataContext.statusCode != FetrapiEnums.DatasetStatusCode.Archived && dataContext.statusCode != FetrapiEnums.DatasetStatusCode.Created) {
      return "<button type='button' class='btn btn-sm btn-default'>Download</Button>";
    }
    return "";
}

approveDataset(context: any)
{
  console.log(context);
  var status = FetrapiEnums.DatasetStatusCode.AdminApproved;
  this.api.updateDatasetStatus(context.datasetId, status).subscribe({
    next: (data: any) => {
      //Reload table
      this.loadDatasets();

    },
    error: (error: any) => {
      if (error.status == 404) {
        this.appService.showModalError('File not found');
      } else {
        this.api.errorhandler(error);
      }
    }
  })
}
rejectDataset(context: any)
{
  var status = FetrapiEnums.DatasetStatusCode.AdminRejected;
  this.api.updateDatasetStatus(context.datasetId, status).subscribe({
    next: (data: any) => {
      //Reload table
      this.loadDatasets();

    },
    error: (error: any) => {
      if (error.status == 404) {
        this.appService.showModalError('File not found');
      } else {
        this.api.errorhandler(error);
      }
    }
  });
}

  downloadDataset(context: any) {
    this.api.downloadDataset(context.datasetId).subscribe({
      next: (data: any) => {
        const element = document.createElement('a');
        element.href = data;
        document.body.appendChild(element);
        element.click();
      },
      error: (error: any) => {
        if (error.status == 404) {
          this.appService.showModalError(error.error.message);
        } else {
          this.api.errorhandler(error);
        }
      }
    })
  }
}
